<template>
  <div>
    <van-field
      v-model="telCode"
      name="验证码"
      label-width="2rem"
      placeholder="请输入验证码"
      :rules="[{ required: true, message: '请输入验证码' }]"
    >
      <template #label>
        <span class="ts">*</span>
        验证码
      </template>
      <template #button>
        <van-button
          size="mini"
          :disabled="count ? true : false"
          @click="reGetValidateImg"
          native-type="button"
          type="primary"
          color="#4967B7"
          >{{ count ? `${count}秒后再次发送` : "获取验证码" }}</van-button
        >
      </template>
    </van-field>
    <!-- 图形验证码 -->
    <van-dialog
      v-model="imgValidateShow"
      title="请输入图片验证码"
      show-cancel-button
      :lazy-render="false"
      confirm-button-text="提交"
      confirm-button-color="#2693E7"
      :beforeClose="getCode"
    >
      <div class="validateBox">
        <img :src="validateImg" @click="reGetValidateImg" />
        <van-field
          v-model="validateValue"
          placeholder="请输入验证码"
          input-align="left"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      telCode: "", //验证码
      //倒计时
      count: "",
      timer: null,

      validateImg: "",
      imgValidateShow: false,
      validateValue: ""
    };
  },
  methods: {
    checkPhone() {
      let reg = /^1[3456789]\d{9}$/;
      if (!this.$parent.$parent.form.reflectTel) { 
        this.$toast.fail("请输入反映人电话");
        return false;
      } else if (!reg.test(this.$parent.$parent.form.reflectTel)) {
        // this.$toast.fail("反映人电话格式错误");
        return false;
      } else {
        return true;
      }
    },
    reGetValidateImg () {
      if (this.checkPhone()) {
        this.$http
          .getCheckCode({ phone: this.$parent.$parent.form.reflectTel })
          .then(res => {
            // 文件数据
            // const blob = new Blob([res]);
            this.validateImg = res;
            this.imgValidateShow = true;
          });
      }
    },
    getCode(action, done) {
      if (action === "confirm") {
        if (this.validateValue == "") {
          this.$toast.fail("请输入验证码!");
          done(false);
        } else {
          //验证手机号
          this.$http
            .registerYzm({
              phone: this.$parent.$parent.form.reflectTel,
              captcha: this.validateValue,
              areaCode: "3708"
            })
            .then((res) => {
              if (res.result) {
                //获取验证码成功后
                this.getShowCode();
                done(true);
              } else {
                this.$toast.fail(res.message);
                this.validateValue = "";
                this.reGetValidateImg();
                done(false);
              }
            })
            .catch(err => {
              this.validateValue = "";
              this.reGetValidateImg();
              done(false);
            })
        }
      } else {
        this.imgValidateShow = false;
        this.validateValue = "";
        done(true);
      }
    },
    getShowCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    }
  },
  mounted () {
  },
};
</script>

<style lang="less" scoped>
.van-cell {
    background-color: #f1f1f1;
    // padding: 10px;
    margin: 10px 0;
    // width: auto;
    border-radius: 5px;
  }
  .validateBox{
    padding: 20px 20px;
    display: flex;
    align-items: center;
    img{
      width: 100px;
    }
  }
</style>